export default __webpack_public_path__ + "static/media/v2-hero-relief.6456438b.jpg";